import axios from 'axios';

const GetBlogListApi = () => {
	return axios.get('https://backend.planmyleisure.com/blog/get-blogs');
};

export default GetBlogListApi;
